define.alias("shared/components/shared/pre-boarding/social-connect/index", "settings/components/shared/pre-boarding/social-connect/index");